module.exports = __webpack_public_path__ + "static/media/8.c230c3d2.jpg";